import React, { useCallback } from "react";
import { StyleSheet, TouchableHighlight } from "react-native";

import { TextLabel, Col, Icon, Row, TextBody } from "../lib";
import { ellipsis } from "../services";
import { colors, createStyles } from "../theme";
import { Badge } from "./badge";
import { AvatarText } from "./avatar-text";

type Props = {
  disabled?: boolean;
  id: number;
  onPress: (id: number, userName: string) => void;
  message?: string;
  unread?: number;
  userId: number;
  userName: string;
  userScore?: number;
};

export function ChatItem({
  disabled = false,
  id,
  onPress,
  message,
  unread,
  userId,
  userName,
  userScore,
}: Props) {
  // Handlers
  const handlePress = useCallback(() => {
    onPress(id, userName);
  }, [id, onPress, userName]);

  // Render
  return (
    <TouchableHighlight underlayColor={colors.background} onPress={handlePress}>
      <Col style={[$.container, disabled && $.disabled]}>
        <Row>
          <AvatarText
            disabled={disabled}
            small
            userId={userId}
            userName={userName}
          />
          <Col pl="4">
            <Row.L>
              <TextBody em={!!unread}>{userName}</TextBody>
              {!!userScore && (
                <Row.L ml="2">
                  <TextLabel mr="1">{Number(userScore).toFixed(1)}</TextLabel>
                  <Icon name="star" small />
                </Row.L>
              )}
            </Row.L>
            {!!message && (
              <TextLabel style={$.message}>{ellipsis(message, 40)}</TextLabel>
            )}
          </Col>
        </Row>
        {!!unread && !disabled && <Badge title={unread} />}
        {disabled && (
          <TextLabel em small>
            BLOCKED
          </TextLabel>
        )}
      </Col>
    </TouchableHighlight>
  );
}

const $ = createStyles({
  container: {
    row: 4,
    p: "4",
    justifyContent: "space-between",
    backgroundColor: "surface",
    borderBottomColor: colors.outline,
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  message: {
    color: "onSurfaceDim",
  },
  disabled: {
    backgroundColor: "surfaceDim",
  },
  // TODO
  // support: {
  //   backgroundColor: t.colors.primary,
  // },
  // supportText: {
  //   color: t.colors.white,
  // },
});
